import React from 'react';

interface FAQ {
    question: string;
    answer: string;
}

interface FAQSectionProps {
    faqs: FAQ[];
}

const FAQSection = ({ faqs }: FAQSectionProps) => {
    if (!faqs || faqs.length === 0) return null;

    return (
        <section className="py-16 bg-white">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center">
                    Perguntas Frequentes
                </h2>
                <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
                    {faqs.map((faq, index) => (
                        <div key={index} className="bg-gray-50 rounded-lg p-6 border border-gray-100">
                            <h3 className="text-xl font-bold text-gray-900 mb-3">
                                {faq.question}
                            </h3>
                            <p className="text-gray-600">
                                {faq.answer}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default FAQSection;
